import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { LandingPage } from './Landing/Landing';
import { SiteContextProvider } from './Context/SiteContext';
import { Business } from './Business/Business';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <SiteContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path='/founder' element={<Business></Business>}></Route>
                    <Route path='/business' element={<Business></Business>}></Route>
                    <Route path='*' element={<LandingPage></LandingPage>}></Route>
                </Routes>
            </BrowserRouter>
        </SiteContextProvider>
    </React.StrictMode>
);
